module.exports = __webpack_public_path__ + "static/img/company.16c813a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company.jpg
// module id = d1eR
// module chunks = 1